import React from "react";
import {Button, Form, Input, Modal, Radio} from "antd";
import {FormModalProps} from "../../utils/useFormModal";
import Upload from "../../components/Upload";
import Select from "../../components/Select";
import Editor from "../../components/Editor";

function ModifyModal(props: FormModalProps) {

    const {form, ...otherProps} = props

    return (
        <Modal width={900} {...otherProps}>
            <Form form={form} layout={'vertical'}>
                <Form.Item label={'主题'} name={'title'} rules={[{required: true, message: '请输入主题'}]}>
                    <Input/>
                </Form.Item>
                <Form.Item label={'发布部门'} name={'department'}>
                    <Input/>
                </Form.Item>
                <Form.Item label={'加盟商发布范围'} name={'type'} initialValue={0}>
                    <Radio.Group>
                        <Radio value={0}>全部</Radio>
                        <Radio value={1}>部分</Radio>
                    </Radio.Group>
                </Form.Item>
                <Form.Item noStyle dependencies={['type']}>
                    {({getFieldValue}) => {
                        const type = getFieldValue('type')
                        return type ? (
                            <Form.Item label={'加盟商'} name={'dealers'}
                                       rules={[{required: true, message: '请选择加盟商'}]}>
                                <Select url={'/dealer/dict'}
                                        textField={'name'}
                                        valueField={'id'}
                                        getData={data => data.data}
                                        mode={"multiple"}
                                />
                            </Form.Item>
                        ) : null
                    }}
                </Form.Item>
                <Form.Item label={'附件'} name={'attachments'}>
                    <Upload beforeUpload={() => false} maxCount={10} multiple={true}>
                        <Button type={'primary'}>上传</Button>
                    </Upload>
                </Form.Item>
                <Form.Item label={'发布内容'} name={'contentRaw'}>
                    <Editor contentStyle={{height: 250}} uploadPrefix={'bulletin/editor'}/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ModifyModal
